import React, { useCallback } from 'react';

import {useI18n} from '../../../../../../../data/hooks/i18nHooks';
import {useMyUserId} from '../../../../../../../data/hooks/sessionHooks';
import { useUserQuestions } from '../../../../../../../data/hooks/questions/useUserQuestions';
import ContainedImage from '../../../../../../elements/ContainedImage';
import styles from '../BubbleMenu.module.scss';

const Quests = props => {
    const {event, user} = props,
        selfId = useMyUserId(),
        isMe = user.user_id == selfId,
        questions = useUserQuestions(event.id, user.user_id).sort((q1, q2) => q2.lastUpdateTimestamp - q1.lastUpdateTimestamp),
        href = ['/events', event.id, 'qa', 'all', 'question', questions[0]?.id].join('/'),
        i18n = useI18n();

    const handleClick = useCallback(() => {
        app.history.push(href);
    }, [href]);

    if (isMe) return null;
    if (!questions.length) return null;

    return (
        <button className={styles.questButton} type="button" onClick={handleClick}>
            <span className={styles.label}>{i18n['label.startnetworking.quests']}</span>
            <ContainedImage src="/img/quests-icon.png" color="white" />
        </button>
    );
};

export default Quests;
